import React from 'react';

class MobileCoreHeader extends React.Component {
  render() {
    return(
      <div className="core-header-mobile">
        <span>People you may know</span>
      </div>
    )
  }
}

export default MobileCoreHeader;
